"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let LoginLogsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.account = "";
    this.name = "";
    this.id = "";
    this.login_ip = "";
    this.login_region = "";
    this.operator_name = "";
    this.login_date = 0;
  }
};
LoginLogsModel.model = "model.login.log";
LoginLogsModel = __decorateClass([
  Annotation.ModelMeta
], LoginLogsModel);
export let ManageLogsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
    this.createdTime = 0;
    this.ip = "";
    this.vdName = "";
    this.comment = "";
  }
};
ManageLogsModel.model = "model.manage.log";
ManageLogsModel = __decorateClass([
  Annotation.ModelMeta
], ManageLogsModel);
export let AccessLogsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.created_time = 0;
    this.description = "";
    this.operator_account = "";
    this.operator_ip = "";
    this.operator_name = "";
    this.vd_name = "";
  }
};
AccessLogsModel.model = "vd_operation_log";
AccessLogsModel = __decorateClass([
  Annotation.ModelMeta
], AccessLogsModel);
export let RiskLogsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.risk_confirm_status = false;
    this.risk_confirm_time = 0;
    this.risk_description = "";
    this.risk_event_status = 0;
    this.risk_name = "";
    this.risk_occur_time = 0;
    this.risk_operator_account = "";
    this.risk_operator_name = "";
    this.risk_type_desc = "";
  }
};
RiskLogsModel.model = "risk_event_log";
RiskLogsModel = __decorateClass([
  Annotation.ModelMeta
], RiskLogsModel);
export let ShopLogsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.account_user_guid = "";
    this.lastlogin_time = 0;
    this.account_name = "";
    this.account = "";
    this.vd_ip = "";
    this.login_shop = "";
    this.operating_information = "";
    this.login_type = "";
    this.shop_guid = "";
  }
};
ShopLogsModel.model = "shop.risk.center.log";
ShopLogsModel = __decorateClass([
  Annotation.ModelMeta
], ShopLogsModel);
